import React, {useRef, useState, useEffect } from "react";
import { Button } from "rsuite";
import { numberFormatter } from "../../utils";
import { CSVLink, CSVDownload } from "react-csv";

const Details = (props: any) => {
	const { detailsData, detailViewType, exportData } = props;

	const exportFullRef=useRef<any>(null);

  	const exportExcel=()=>{
		props?.getExportData()
	}

	  const csvHeaders = [
    { label: "Plant Wrks", key: "PLANT_PLANT" },
    { label: 'For a District', key: "district" },
    { label: "L3", key: "l3" },
    { label: "L4", key: "l4"},
    { label: "Master Vendor Name", key: "master_vendor_name" },
    { label: "Preferred Supplier Flag", key: "prefferedFlag" },
    { label: "2024 YTD Spend", key: "costLy" },
    { label: "2025 YTD Spend", key: "cost" },
    { label: "Gross Margin", key: "" },
    { label: "Spend %", key: "" },

  ]

  useEffect(()=>{
    if(exportData?.length!==0){
      exportFullRef?.current?.link.click();
      console.log('here');
      
    }
  },[exportData])

	console.log(detailsData, "detailsData");

	return (
		<>
			<div className="overview-container contentBox flex flex-col gap-y-[2vh]">
				{(detailsData.length>0 && detailViewType =='marginTrend') || (detailsData.length>0 && props.selectedL4) ? (
					<>
						<div className="max-h-full overflow-y-auto">
							<table className="common-table-ui">
								<thead>
									<tr>
										<th>Supplier</th>
										<th>2025 YTD Sales</th>
										<th>Gross Margin</th>
										<th>Spend Shift compared to 2024</th>
										<th>Recommendation</th>
									</tr>
								</thead>
								<tbody>
									{detailsData.map((d: any, index: any) => {
										return (
											<tr key={d.master_vendor_name}>
												<td>{d.master_vendor_name}</td>
												<td>
													{numberFormatter(
														d.ytdSales,
														0,
														"$"
													)}
												</td>
												<td>
													{(
														d.marginSupplierYTD *
														100
													).toFixed(0)}{" "}
													%
													<span className="text-[1.2vh]">
														{` (
                                ${
									(d.marginSupplierYTD - d.marginSupplierLY) *
										100 >=
									0
										? "+"
										: ""
								}
                                ${(
									(d.marginSupplierYTD - d.marginSupplierLY) *
									100
								).toFixed(0)}%)`}
													</span>
												</td>
												<td>
													{" "}
													{d.spendShiftPrcnt.toFixed(
														2
													)}{" "}
													%
												</td>
												<td>-</td>
											</tr>
										);
									})}
									{/* <tr className="total-row">
                        <td className="center">Total</td>
                        <td>{numberFormatter(data.spend, 0, "$")}</td>
                        <td>
                          {numberFormatter(data.niaEarnings, 0, "$")}
                        </td>
                        <td>
                          {numberFormatter(data.grossMargin, 2)} %
                        </td>
                        <td>{numberFormatter(data.grossMargin, 2)}</td>
                      </tr> */}
								</tbody>
							</table>
						</div>
						<div className="w-full flex justify-center">
							<button
								className="text-[0.7vw] w-[8vw] bg-green-700 px-2 py-1 rounded-md"
								onClick={exportExcel}
							>
								SKU Level Export
							</button>
							<CSVLink 
								ref={exportFullRef} 
								data={exportData} 
								headers={csvHeaders}
								filename="preferred_supplier.csv" 
								className="hidden" 
								target="_blank"
								> 
							</CSVLink>
						</div>
					</>
				) : (
					<div className=" h-full flex justify-center items-center italic ">
						<span className="text-center text-black text-[2.5vh]">
							 Please select the L4 from the LHS table header.
						</span>
					</div>
				)}
			</div>
		</>
	);
};
export default Details;
